window.BMIBerater = function (element) {
  this.renderer = element;
  this.screen1 = this.renderer.querySelector('.screen-1');
  this.screen2 = this.renderer.querySelector('.screen-2');
  this.overlay = this.renderer.querySelector('.overlay');
  this.feedback = this.renderer.querySelector('.feedback');
  this.init();
};
window.BMIBerater.prototype = {
  init: function () {
    this.submit = this.renderer.querySelector('.submit');
    this.submit.addEventListener('click', this.onSubmit.bind(this));

    this.retry = this.renderer.querySelector('.retry');
    this.retry.addEventListener('click', this.onRetry.bind(this));

    this.moreInfo = this.renderer.querySelector('.more-info');
    this.moreInfo.addEventListener('click', this.onMoreInfo.bind(this));

    this.closeOverlay = this.renderer.querySelector('.close-overlay');
    this.closeOverlay.addEventListener('click', this.onCloseOverlay.bind(this));

    var s = this.renderer.querySelectorAll('.display-value');
    for (var i = 0; i < s.length; i++) {
      var input = s[i].querySelector("input[type='text']");
      var range = s[i].querySelector("input[type='range']");

      input.addEventListener('change', this.changeInput.bind(this));
      range.addEventListener('change', this.changeRange.bind(this));
      range.addEventListener('input', this.changeRange.bind(this));

      input.value = range.value;
    }
  },
  changeInput: function (evt) {
    var input = evt.currentTarget;
    var range = input.parentElement.querySelector("input[type='range']");
    range.value = parseInt(input.value);
  },
  changeRange: function (evt) {
    var range = evt.currentTarget;
    var input = range.parentElement.querySelector("input[type='text']");
    input.value = range.value;
  },
  validInput: function () {},
  onSubmit: function () {
    var gender = this.renderer.querySelector('input[name="gender"]:checked').value;
    var age = this.renderer.querySelector('#age').value;
    var height = this.renderer.querySelector('#height').value;
    var weight = this.renderer.querySelector('#weight').value;

    var result = this.getResult(gender, age, height, weight);

    var feedback = '<div class="bmi big">' + result.bmi.toFixed(1).replace('.', ',') + '</div>';

    feedback += result.title;

    this.feedback.innerHTML = feedback;
    this.screen1.classList.add('hidden');
    this.screen2.classList.remove('hidden');
  },
  onRetry: function () {
    this.screen2.classList.add('hidden');
    this.screen1.classList.remove('hidden');
  },
  onMoreInfo: function () {
    this.overlay.classList.remove('hidden');
    document.body.classList.add('has-overlay');
  },
  onCloseOverlay: function () {
    this.overlay.classList.add('hidden');
    document.body.classList.remove('has-overlay');
  },
  getResult: function (gender, age, height, weight) {
    var hm = height / 100;
    var bmi = weight / (hm * hm);
    var nv, title;
    var normalValues = [
      [24, 19, 24],
      [34, 20, 25],
      [44, 21, 26],
      [54, 22, 27],
      [64, 23, 28],
      [200, 24, 29],
    ];
    for (var i = 0; i <= normalValues.length; i++) {
      if (normalValues[i][0] > age) {
        nv = normalValues[i];
        break;
      }
    }

    var classification = this.getClassification(nv, bmi);
    this.feedback.className = 'feedback col-12 col-lg-8 bmi-class-' + classification.index;

    switch (classification.label) {
      case 'Untergewicht':
        title =
          'Dieser Wert liegt für Deine Altersgruppe unter dem Normalbereich von <b>' +
          nv[1] +
          ' bis ' +
          nv[2] +
          '</b>.<br>Die Ursache dafür kann verschiedene Gründe haben.<br><br>';
        title +=
          'Bitte beachte: Der BMI-Wert bietet eine Orientierungshilfe, sollte aber immer individuell betrachtet werden. Wir empfehlen Dir, ein Gespräch mit Deinem Arzt oder einer Ernährungsberatungsstelle in Deiner Nähe zu führen. Weitere Informationen erhältst Du auch bei Deiner Krankenkasse.';
        break;
      case 'Normalgewicht':
        title =
          '<b>Sehr gut!</b><br>Dieser Wert liegt für Deine Altersgruppe im Normalbereich von <b>' +
          nv[1] +
          ' bis ' +
          nv[2] +
          '</b>.<br><br>';
        title +=
          'Du scheinst auf eine gesunde und ausgewogene Ernährung zu achten und auch die Bewegung kommt bei Dir nicht zu kurz. Mach weiter so!';
        break;
      case 'Übergewicht':
        title =
          '<b>Nicht schlecht, aber auch nicht ganz perfekt</b><br>Dieser Wert liegt für Deine Altersgruppe leicht über dem Normalbereich von <b>' +
          nv[1] +
          ' bis ' +
          nv[2] +
          '</b>.<br><br>';
        title +=
          'Mit einer gesunden und ausgewogenen Ernährung und regelmäßiger Bewegung kannst Du Dein Gewicht langfristig reduzieren.<br><br>';
        title +=
          '<p>Hinweis: Sportler haben auf Grund ihrer größeren Muskelmasse oftmals einen BMI-Wert über 25. In diesem Fall liegt kein Übergewicht vor.</p>';
        break;
      case 'Adipositas':
      case 'massive Adipoitas':
        title =
          'Dieser Wert liegt für Deine Altersgruppe deutlich über dem Normalbereich von <b>' +
          nv[1] +
          ' bis ' +
          nv[2] +
          '</b>.<br><br>';
        title +=
          'Dein Gewicht kann zum gesundheitlichen Risiko werden. Wir empfehlen Dir, ein Gespräch mit Deinem Arzt zu führen. Mit einer gesunden und ausgewogenen Ernährung und regelmäßiger Bewegung kannst Du Dein Gewicht langfristig reduzieren.';
        break;
    }
    return { bmi: bmi, title: title, txt: 'Result' + gender + ' ' + age + ' ' + height + ' ' + weight };
  },
  getClassification: function (nv, bmi) {
    var values = [[nv[1]], [nv[2]], [30], [40], [1000]];
    var states = ['Untergewicht', 'Normalgewicht', 'Übergewicht', 'Adipositas', 'massive Adipoitas'];

    for (var i = 0; i <= values.length; i++) {
      if (values[i][0] > bmi) {
        return { index: i, label: states[i] };
      }
    }

    return { index: values.length - 1, label: states[values.length - 1] };
  },
};
